import { mapActions, mapGetters } from "vuex";

import listItem from "./list-item/index.vue";

export default {
    name: "archive-order",
    data() {
        return {};
    },
    head: {
        title: function() {
            return {
                inner: "Точка ",
                separator: "|",
                complement: "Архівні замовлення",
            };
        },
    },
    components: {
        "list-item": listItem,
    },
    computed: {
        ...mapGetters({
            archiveOrderList: "profile/archiveOrderList",
            archiveOrderListLength: "profile/archiveOrderListLength",
            archiveOrderListLoading: "profile/archiveOrderListLoading",
        }),
    },
    created() {
        this.fetchArchiveOrderList();
    },
    methods: {
        ...mapActions({
            fetchArchiveOrderList: `profile/GET_ARCHIVE_ORDER_LIST`,
        }),
    },
};
